<template>
  <div v-loading="loading" class="alarmClass">
    <div>
      <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="105px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="服务网点" prop="nursinghomeId" required>
              <el-select
                disabled
                v-model="form.nursinghomeId"
                style="width:100%"
                placeholder="请选择 服务网点"
              >
                <el-option
                  v-for="item in nursinghomeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="服务类型" prop="serviceType">
              <el-select  
              @change="serviceTypeChange"
              :disabled="model === 'view'"
                v-model="form.serviceType" style="width:100%" placeholder="请选择 服务类型">
                <el-option
                  v-for="item in typeDice"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="服务项目" prop="serviceItemId">
              <el-select 
              :disabled="model === 'view'"
                
                clearable
                v-model="form.serviceItemId"
                style="width: 100%"
                placeholder="请选择 服务项目"
              >
                <el-option
                  v-for="item in serviceItemList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            
          <el-form-item label="需求老人" prop="elderlyId">
        <el-select  
        filterable
              @change="elderlyIdChange"
              :disabled="model === 'view'"
                style="width: 100%" placeholder="请选择 需求老人" v-model="form.elderlyId" clearable>
          <el-option
            v-for="(item, index) in elderlyList"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
          </el-form-item>
          </el-col>
          

          <el-col :span="8">
            <el-form-item label="联系电话" prop="tel">
              <el-input 
              :disabled="model === 'view'"
                
                v-model="form.tel"
                maxlength="20"
                showWordLimit
                type="text"
                clearable
                style="width:100%;"
                placeholder="请输入 联系电话"
              ></el-input>
            </el-form-item>
          </el-col>


          <el-col :span="8">
            <el-form-item label="期望到场时间" label-width="90" prop="expectArriveTime"> 
              <el-date-picker 
              :disabled="model === 'view'"
                style="width: calc(100% - 109px);" 
                value-format="yyyy-MM-dd HH:mm:ss" 
                v-model="form.expectArriveTime" 
                type="datetime" 
                placeholder="请选择 期望到场时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          
          
          <el-col :span="24">
            <el-form-item label="服务地点" prop="serviceAddress">
              <el-input 
              :disabled="model === 'view'"
                
                v-model="form.serviceAddress"
                maxlength="200"
                showWordLimit
                type="text"
                clearable
                placeholder="请输入 服务地点"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="需求描述" prop="description">
              <el-input 
              :disabled="model === 'view'"
                
                v-model="form.description"
                maxlength="300"
                showWordLimit
                type="textarea"
                clearable
                placeholder="请输入 需求描述"
              ></el-input>
            </el-form-item>
          </el-col>
          
          <el-col :span="24">
            记录信息
          </el-col>
          <el-col :span="12">
            <el-form-item label="服务人员" prop="servicePeopleName">
              <el-input 
              :disabled="model === 'view'"
                
                v-model="form.servicePeopleName"
                maxlength="20"
                showWordLimit
                type="text"
                clearable
                placeholder="请输入 服务人员"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="服务费用" prop="servicePrice">
              
          <moneyInput 
            v-model="form.servicePrice"
            :disabled="model == 'view'"
            placeholder="请输入金额"
            :template="'no'"
          />
            </el-form-item>
          </el-col>

          
        <el-col :span="24">
          <el-form-item label="服务时间" prop="timeRange">
            <el-date-picker
              :disabled="model === 'view'"
              v-model="form.timeRange"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
          <el-col :span="24">
            <el-form-item label="服务过程记录" prop="serviceLog">
              <el-input 
              :disabled="model === 'view'"
                
                v-model="form.serviceLog"
                maxlength="300"
                showWordLimit
                type="textarea"
                clearable
                placeholder="请输入 服务过程记录"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="附件上传" prop="attachIdsList">
              
                <vUpload
                :disabled="model=='view'"
                :message="'提示：上传文件不大于12MB，数量最多3张'"
                :types="['doc', 'docx', 'ppt', 'pptx', 'txt', 'xlsx', 'xls', 'pdf', 'jpg', 'png']"
                :max="12582912"
                :limit="3"
                :fileList.sync="form.attachIdsList"
              ></vUpload>
            </el-form-item>
          </el-col>

          </el-row>
      </el-form>
    </div>
    <div style="    text-align: right;" v-if="model != 'view'">
      <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
        {{ model == 'add' ? '提交' : '修改' }}
      </el-button>
      <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small">
        取消
      </el-button>
    </div>
  </div>
</template>
<script>
import { getNursinghomeList } from '../api/public.js';
import { getDictionary } from '@/api/common.js';
import {
  getElderlyListApi,
} from '../api/mandateManage';
import { getList, serviceItemListAll, add, update, getDetail} from '../api/nursinghomeserviceitemlog.js';
import { serviceItemSave,serviceItemDetail,serviceItemUpdate } from '../api/serveItemManage.js';

import vUpload from '../components/mutil-upload.vue';
import dayjs from 'dayjs';
export default {
  components: {
    vUpload
  },
  props: {
    row: {
      default: {},
    },
    nursinghomeId: {},
    model: {
      default: 'add',
    },
  },
  data() {
    return {
      nursinghomeList: [],
      typeDice: [],
      form: {
        timeRange:[],
        nursinghomeId: '',
        serviceType: '',
        serviceItemId: '',
        elderlyId:'',
        description:"",
        expectArriveTime:'',
        serviceLog:'',
        attachIdsList:[],
      },
      formRules: {
        timeRange: [{ required: true, message: '服务时间不能为空', trigger: 'change' }],
        tel: [{ required: true, message: '联系电话不能为空', trigger: 'blur' }],
        serviceItemId: [{ required: true, message: '服务项目不能为空', trigger: 'change' }],
        nursinghomeId: [{ required: true, message: '服务网点不能为空', trigger: 'change' }],
        serviceType: [{ required: true, message: '服务类型不能为空', trigger: 'change' }],
        servicePeopleName: [{ required: true, message: '服务人员不能为空', trigger: 'blur' }],
        servicePrice: [{ required: true, message: '服务费用不能为空', trigger: 'blur' }],
        elderlyId: [{ required: true, message: '需求老人不能为空', trigger: 'change' },
              // { pattern: /^\+?[1-9][0-9]*$/, message: '只能输入正整数', trigger: 'change'}
              ],
      },
      matetialList: [],
      serviceItemList: [],
      elderlyList:[],
    };
  },
  created() {
    this.initData();
  },
  mounted() {},
  watch: {},
  methods: {
    serviceTypeChange(val){
      this.form.serviceItemId =''
        serviceItemListAll({
          nursinghomeId: this.form.nursinghomeId,
          serviceType: this.form.serviceType
}).then(({data})=>{
            this.serviceItemList = data;
            if(data.length>0){
              this.form.serviceItemId = data[0].id;
            }
            
})
    },
    elderlyIdChange(id){
      let self = this;
      this.elderlyList.forEach(ele=>{
        if(id===ele.id){
self.form.tel = ele.tel;
        }
      })
      this.form = this._.cloneDeep(self.form);
    },
   getAttachIds(){
    if(this.form.attachIdsList.length>0){
      let idList = [];
      this.form.attachIdsList.forEach(ele=>{
        idList.push(ele.id);
      })
      this.form.attachIds = idList.join(',');
    }
   },
    transferTime() {
      console.log('this.form.timeRange=========>', this.form.timeRange);
      if (this.form.timeRange && this.form.timeRange.length > 0) {
        this.form.serviceStartTime = dayjs(this.form.timeRange[0]).format(
          'YYYY-MM-DD HH:mm:ss'
        );
        this.form.serviceEndTime = dayjs(this.form.timeRange[1]).format('YYYY-MM-DD HH:mm:ss');
      } else {
        this.form.serviceStartTime = '';
        this.form.serviceEndTime = '';
      }
    },
    async initData() {
      getDictionary('nursinghome_service_type').then((res) => {
        this.typeDice = res.data;
this.form.serviceType = res.data[0].dictKey;
      getNursinghomeList().then((res) => {
        this.nursinghomeList = res.data;
      if (this.model == 'add') {
        serviceItemListAll({
          nursinghomeId: this.form.nursinghomeId,
          serviceType: this.form.serviceType
}).then(({data})=>{
            this.serviceItemList = data;
            this.form.serviceItemId = data[0].id;
})
      }



        // 更新老人列表
        getElderlyListApi({
          id: this.form.nursinghomeId,
        })
          .then(({ data }) => {
            this.elderlyList = data;
            // this.form.elderlyId = data[0].id;
            // if (this.elderlyList.length > 0) {
            //   // 要先获取到老人列表再去获取表格数据，否则表格数据里的老人信息渲染不出来
            //   if (this.isFirstLoadData) {
            //     this.isFirstLoadData = false;
                // 老人的更新一定要注意时机，否则表格里的老人会显示成id，并非name
                // this.findObject(this.tableOption.column, 'elderlyId').dicData = this.elderlyList;
                // this.loadData();
                this.onLoad();
            //   }
            // } else {
            // //   this.isFirstLoadData = false;
            // }
          })
          .catch(() => {
            // this.isFirstLoadData = false;
          });
      });
      });
      if (this.model == 'add') {
        this.form.nursinghomeId = this.nursinghomeId;
        
      } else {
        getDetail({id:this.row.id}).then((res) => {
          this.form = res.data;
          this.form.timeRange = [dayjs(this.form.serviceStartTime),dayjs(this.form.serviceEndTime)]
          // let arr = this.form.attachIds.split(',');
          
          // this.form.attachIdsList = [];
          // let self = this;
          // arr.forEach(ele=>{
          //   self.form.attachIdsList.push({id:ele});
          // })
          this.form.attachIdsList = this.form.attachIdsList;
        serviceItemListAll({
          nursinghomeId: this.form.nursinghomeId,
}).then(({data})=>{
            this.serviceItemList = data;
            this.form.serviceItemId = data[0].id;
})
        })
      }
    },
    saveRecord() {
      this.transferTime();
      this.getAttachIds();
      this.$refs['formRef'].validate((valid) => {
        if (valid) {
          if ((this.model == 'add')) {
            add(this.form).then((res) => {
              this.$message.success('新增成功');
              this.$emit('success');
            });
          }else{
            update(this.form).then((res) => {
              this.$message.success('修改成功');
              this.$emit('success');
            });
          }
        }
      });
    },
    cancleRecord() {
      this.$emit('cancle');
    },
  },
};
</script>
<style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
::v-deep .el-col-8 {
  height: 54px;
}
</style>
